export let routinecivil =`
<div>
<p class="ql-align-center" style="text-align: center !important;"><em>RESTRICTED</em></p>

<div class="ql-align-center">
<h3><p>Armed Forces Command  </p>
<p>and Staff College </p>
<p>PMB 2234</p> <p>Jaji-Kaduna</p>
</h3>
</div>
AFCSC/125/G   							



<p>
<p>Atlas Nigeria Limited    </p>
<p>Development House </p>
<p>PMB 2320</p>
<p>LAGOS</p>

<div class="ql-align-center">
<h3><p style='color:red'>July 2013</p>
</h3>
</div>


<div>

Dear Sir,

<p><u><strong>MAINTENANCE OF PRINTING MACHINERY </u></strong></p><br>

<p>1.	Thank you for your letter ANL/15 dated 2 June 2013 confirming that your service technician will be able to visit the Armed Forces Command and Staff College on 26 September 2013. Provided you inform us of his arrival details, we shall arrange reception and transport from Kaduna Airport.</p><br>
<p>2. Please submit your account to the Finance Officer at the above address.  Should further enquiries be required, please contact the undersigned.</p>
<br>
</div><br>

<div class="ql-align-center">


<h3>
<p>Yours faithfully</p>


<br>
<p style="color:red">A YUSUF</p>
<p>Colonel</p>
<p>for Commandant</p>
</h3>


</div>
</p>






<p class="ql-align-justify" style="text-align: center;"><em style='color: rgb(0, 0, 0); font-family: "Times New Roman"; font-size: medium; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: normal; orphans: 2; text-align: left; text-indent: 0px; text-transform: none; white-space: normal; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial;'>RESTRICTED</em>&nbsp;</p>

</div>

`